export default {
  path: '/prod_files',
  name: 'prod_files',
  component: () => import('../components/prodfile/Layout'),
  redirect: { name: 'ProdFileList' },
  meta: {
    breadcrumb: 'prodfile.prodfiles',
  },
  children: [
    {
      name: 'ProdFileList',
      path: '',
      component: () => import('../views/prodfile/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProdFileCreate',
      path: 'new',
      component: () => import('../views/prodfile/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProdFileUpdate',
      path: ':id/edit',
      component: () => import('../views/prodfile/Update'),
      meta: {
        breadcrumb: 'prodfile.prodfile',
      },
    },
    {
      name: 'ProdFileShow',
      path: ':id',
      component: () => import('../views/prodfile/Show'),
      meta: {
        breadcrumb: 'prodfile.prodfile',
      },
    }
  ]
};
